import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPostBySlug } from '../../services/blogService';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const BlogPost = () => {
    const { slug } = useParams();
    const post = getPostBySlug(slug);

    // Debugging logs
    console.log('Slug:', slug);
    console.log('Post:', post);

    if (!post) {
        return (
            <div style={{ padding: '24px', textAlign: 'center' }}>
                <p style={{ fontSize: '1.25rem', color: '#555' }}>Post not found.</p>
                <Link to="/blog" style={{ color: '#3498db', textDecoration: 'none', fontWeight: '500' }}>
                    Return to Blog
                </Link>
            </div>
        );
    }

    // Validate and sanitize post.content
    const content = typeof post.content === 'string' ? post.content : 'Content unavailable.';

    return (
        <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '2rem', marginBottom: '16px', color: '#222', fontWeight: '500' }}>
                {post.title}
            </h1>
            <small style={{ display: 'block', marginBottom: '24px', color: '#888', fontSize: '0.85rem', lineHeight: '1.2' }}>
                {new Intl.DateTimeFormat('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                }).format(new Date(post.date))} • {post.author}
            </small>
            <div
                style={{
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#333',
                    marginBottom: '32px',
                }}
            >
                {/* Render the Markdown content */}
                {/*
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                >
                    {content}
                </ReactMarkdown>
                */}
                {/* Render the Markdown content with constrained image width */}
                <div className="blog-post">
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeRaw]}
                        components={{
                            img: ({ node, ...props }) => (
                                <img
                                    {...props}
                                    style={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        margin: '16px auto',
                                    }}
                                />
                            ),
                        }}
                    >
                        {typeof content === 'string' ? content : 'Content unavailable.'}
                    </ReactMarkdown>
                </div>

            </div>
            <Link to="/blog" style={{ color: '#3498db', textDecoration: 'none', fontWeight: '500' }}>
                &larr; Back to Blog
            </Link>
        </div>
    );
};

export default BlogPost;